<template>
  <div style="background-color: #3b425d;
    min-height: 100vh;
    padding: 10px;">
    <ValidationObserver v-slot="{ handleSubmit }">
      <div
        class="content"
        style="max-width:480px; margin:0 auto; color:#FFF;padding-top:30px;"
      >
        <img
          style="display:block; margin:0 auto; max-width:100%; margin-bottom:30px;"
          src="@/assets/img/question.png"
          alt=""
        />
        <input type="hidden" name="ResumeGuid" value="@ViewBag.ResumeGuid" />
        <div style="text-align:center; font-size:2em;">
          是否願意報到？
        </div>

        <div class="switch-wrap">
          <label>
            <input type="radio" :value="true" v-model="OnBoard" />
            <span>是</span>
          </label>

          <label>
            <input type="radio" :value="false" v-model="OnBoard" />
            <span>否</span>
          </label>
        </div>

        <div v-if="!OnBoard" class="decline-block">
          <div class="note">
            感謝您參與本公司面談，請協助填入放棄報到原因，以利本公司記錄，望未來還有合作的機會。
          </div>
          <ValidationProvider v-slot="{ errors }" rules="required">
            <textarea
              rows="5"
              placeholder="請輸入婉拒原因"
              @compositionstart="is_composing = true"
              @compositionend="is_composing = false"
              v-model="Reason"
            />
            <span v-if="errors && !is_composing" class="text-danger">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </div>
        <br />
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary"
            @click="goBack"
            style="margin-right: 15px"
          >
            返回
          </button>
          <button
            type="button"
            class="btn btn-success"
            @click="handleSubmit(replyMessages)"
          >
            送出
          </button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // compositionstart & compositionend
      is_composing: false,

      OnBoard: true,
      Reason: null,
    };
  },
  methods: {
    // 返回前頁
    goBack() {
      this.$router.back();
    },

    // 回覆報到意願 API
    replyMessages() {
      const vm = this;
      const api = `${window.endpoints.api}/Recruitment/OnBoardIntention`;

      const data = {
        MatchId: vm.$route.params.MatchId,
        UserId: vm.$cookies.get("candidateId"),
        OnBoard: vm.OnBoard,
        Reason: vm.Reason,
      };

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "報到意願送出成功",
              type: "success",
              duration: 2000,
            });
            vm.$nextTick(function() {
              vm.$router.back();
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "報到意願送出失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.switch-wrap {
  display: flex;
  border: 2px solid #fff;
  padding: 3px;
  border-radius: 25px;
  margin-top: 30px;
  margin-bottom: 40px;
}

.switch-wrap label {
  flex: 1;
  cursor: pointer;
  margin-bottom: 0;
}

.switch-wrap label input {
  display: none;
}

.switch-wrap label input:checked + span {
  background-color: rgba(255, 255, 255, 0.8);
  color: #267091;
}

.switch-wrap label span {
  display: block;
  line-height: 30px;
  height: 30px;
  text-align: center;
  border-radius: 25px;
}

.decline-block {
  .note {
    letter-spacing: 1px;
  }
  textarea {
    border: none;
    border-radius: 5px;
    display: block;
    padding: 10px;
    min-height: 100px;
    width: 100%;
    margin-top: 30px;
  }
}
</style>
